import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import documentBlueprintKeys from './keyFactory';

const GetDocumentBlueprints = graphql(`
  query GetDocumentBlueprints {
    documentBlueprints {
      id
      name
      description
      documentTemplate {
        id
        name
      }
      fieldGroup {
        id
        customFields {
          id
          label
          identifier
          type
          sortIndex
        }
      }
    }
  }
`);

const useGetDocumentBlueprints = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: documentBlueprintKeys.list(),
    queryFn: () => gqlClient.request(GetDocumentBlueprints),
    enabled: options?.enabled,
  });
};

export default useGetDocumentBlueprints;
